module.exports = __webpack_public_path__ + "static/media/pagenotfound.2c832c17.jpg";